import { Component, Input } from '@angular/core';

import { BannerImageSlot } from '../../../core/models/banner-image-slot.model';

@Component({
  selector: 'app-tecbazar-banners',
  templateUrl: './tecbazar-banners.component.html',
  styleUrls: ['./tecbazar-banners.component.scss']
})
export class TecbazarBannersComponent {
  @Input() bannerSlots: BannerImageSlot[] = [];

  readonly bannerPlaceholder = 'assets/images/product/placeholder.jpg';

  trackByBannerId(_index: number, banner: BannerImageSlot): number {
    return banner.id;
  }
}
